
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"196","height":"141","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M189.912 0l-27.574.811-8.056 43.789-19.958-4.125h-26.627l-8.433 49.409.781-4.549-18.975-3.932-26.628-.694-7.834 45.14-18.918-3.816-25.925-1.191-1.622 8.92 50.946 8.943 27.88.732 7.449-45.053-26.79-5.387 44.821 9.02 28.13.666 7.44-44.813 18.57 3.614 27.321.848 9.678-56.71L189.912 0z","fill":"#FFA423"}}),_c('path',{attrs:{"d":"M48.883 130.582v-6.488l-19.464-4.055-26.762.811 46.226 9.732z","fill":"#FCAB06"}}),_c('path',{attrs:{"d":"M172.07 2.444l23.518-.811-9.651 56.768-23.599.811 9.732-56.768zM114.572 40.547h27.573l-9.732 58.39H104.84l9.732-58.39zM61.047 81.094H88.62l-9.731 58.39-25.221.811 7.38-59.201z","fill":"#FC9601"}}),_c('path',{attrs:{"d":"M101.515 90.02V83.53l-19.463-4.054-28.384.81 47.847 9.732zM155.04 49.472v-6.487l-19.464-4.055-28.384 1.622 47.848 8.92z","fill":"#FCAB06"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M172 2.445l-9.765 56.813-45.455-8.928-8.903 49.372-46.162-8.099-8.129 48.775L0 129.661l1.765-8.827 43.874 8.03 8.09-48.542 45.353 8.073 8.11-47.848 46.226 6.488L162.409.797 172 2.445z","fill":"#FCCD00"}})])
          )
        }
      }
    